export const productionSelections=[
 {
  "tech": "loop-subdivision",
  "ja": {
   "group": "形状",
   "goal": "輪郭が角張る",
   "method": "細分割、必要箇所の追加頂点（Loop）",
   "risk": "頂点数が増えます。稜線や境界には別の規則が必要です"
  },
  "en": {
   "group": "Geometry",
   "goal": "Angular silhouettes",
   "method": "Subdivision or extra vertices where needed",
   "risk": "More vertices increase cost. Creases and boundaries need specific rules."
  }
 },
 {
  "tech": "normal-parallax",
  "ja": {
   "group": "形状",
   "goal": "細かな凹凸が欲しい",
   "method": "法線マップ、輪郭も変えるなら変位",
   "risk": "法線だけでは輪郭と衝突形状は変わりません"
  },
  "en": {
   "group": "Geometry",
   "goal": "Fine surface detail",
   "method": "Normal maps; displacement when silhouettes must change",
   "risk": "Normal maps do not change silhouettes or collision geometry."
  }
 },
 {
  "tech": "progressive-mesh",
  "ja": {
   "group": "形状",
   "goal": "遠景が重い",
   "method": "LOD、ストリーミング（Progressive Mesh）",
   "risk": "切り替えの飛び、読み込み待ちが出ます"
  },
  "en": {
   "group": "Geometry",
   "goal": "Expensive distant scenery",
   "method": "LOD and streaming",
   "risk": "Check detail transitions and loading stalls."
  }
 },
 {
  "tech": "splat",
  "ja": {
   "group": "形状",
   "goal": "実写空間を自由視点で見たい",
   "method": "NeRF、3D Gaussian Splatting",
   "risk": "動く物体、編集、衝突形状の準備は別問題です"
  },
  "en": {
   "group": "Geometry",
   "goal": "View a captured space from new angles",
   "method": "NeRF or 3D Gaussian Splatting",
   "risk": "Moving objects, editing, and collision meshes need separate work."
  }
 },
 {
  "tech": "shadow-map",
  "ja": {
   "group": "光",
   "goal": "物体が浮いて見える",
   "method": "影、接触付近の遮蔽（Shadow Map、AO）",
   "risk": "バイアスの誤り、画面外情報の不足が出ます"
  },
  "en": {
   "group": "Light",
   "goal": "Objects appear to float",
   "method": "Shadows and contact occlusion",
   "risk": "Check shadow bias and missing off-screen information."
  }
 },
 {
  "tech": "lumen-lite",
  "ja": {
   "group": "光",
   "goal": "間接光が平板",
   "method": "ベイクと動的GIを比較",
   "risk": "更新頻度と漏れ光、残像を確認します"
  },
  "en": {
   "group": "Light",
   "goal": "Flat indirect lighting",
   "method": "Compare baked lighting with dynamic GI",
   "risk": "Check update rate, light leaks, and temporal artifacts."
  }
 },
 {
  "tech": "deferred",
  "ja": {
   "group": "光",
   "goal": "小さな光源が多い",
   "method": "光源の影響範囲を絞る、遅延描画など",
   "risk": "画面を覆う光と透明物が負荷を増やします"
  },
  "en": {
   "group": "Light",
   "goal": "Many small lights",
   "method": "Limit light influence; compare deferred rendering",
   "risk": "Large light volumes and transparency increase cost."
  }
 },
 {
  "tech": "cook-torrance",
  "ja": {
   "group": "材質",
   "goal": "金属も樹脂も同じに見える",
   "method": "Microfacet BRDF、PBR",
   "risk": "照明と色空間が不適切だと判断を誤ります"
  },
  "en": {
   "group": "Materials",
   "goal": "Metal and plastic look the same",
   "method": "Microfacet BRDF and PBR",
   "risk": "Incorrect lighting or color space can invalidate the comparison."
  }
 },
 {
  "tech": "dipole",
  "ja": {
   "group": "材質",
   "goal": "肌や蝋に厚みがない",
   "method": "SSS。単純な逆光表現も比較",
   "risk": "逆光の色付けは本来のSSSと同じ計算ではありません"
  },
  "en": {
   "group": "Materials",
   "goal": "Skin or wax lacks thickness",
   "method": "SSS; compare simpler backlighting",
   "risk": "Tinted backlighting is not the same calculation as subsurface scattering."
  }
 },
 {
  "tech": "screen-refraction",
  "ja": {
   "group": "材質",
   "goal": "ガラスや水越しを見せたい",
   "method": "屈折、用途に応じた透過近似",
   "risk": "画面空間方式は画面外や重なりに弱いです"
  },
  "en": {
   "group": "Materials",
   "goal": "See through water or glass",
   "method": "Refraction or a suitable transmission approximation",
   "risk": "Screen-space methods lack off-screen and hidden layers."
  }
 },
 {
  "tech": "inverse-kinematics",
  "ja": {
   "group": "動き",
   "goal": "足が浮く、手が届かない",
   "method": "IKと接地・到達判定",
   "risk": "到達不能、関節制限、姿勢の跳びに注意します"
  },
  "en": {
   "group": "Motion",
   "goal": "Floating feet or unreachable hands",
   "method": "IK with contact and reach checks",
   "risk": "Check joint limits, unreachable goals, and sudden pose changes."
  }
 },
 {
  "tech": "dual-quaternion",
  "ja": {
   "group": "動き",
   "goal": "関節のねじれで潰れる",
   "method": "ウェイト修正、Dual Quaternion Skinning",
   "risk": "方式の変更だけで不適切なリグは直りません"
  },
  "en": {
   "group": "Motion",
   "goal": "Twisting joints collapse",
   "method": "Correct weights; compare dual quaternion skinning",
   "risk": "Changing the algorithm does not repair an unsuitable rig."
  }
 },
 {
  "tech": "motion-matching-2016",
  "ja": {
   "group": "動き",
   "goal": "移動のつなぎが多すぎる",
   "method": "Blend Tree、Motion Matching",
   "risk": "データの不足、検索費用、急な切り替えが問題です"
  },
  "en": {
   "group": "Motion",
   "goal": "Too many movement transitions",
   "method": "Blend trees or motion matching",
   "risk": "Check dataset coverage, search cost, and abrupt transitions."
  }
 },
 {
  "tech": "fixed-timestep",
  "ja": {
   "group": "物理",
   "goal": "FPSで跳ね方が変わる",
   "method": "固定時間刻みと描画補間",
   "risk": "処理落ち時の追いつき計算に上限が必要です"
  },
  "en": {
   "group": "Physics",
   "goal": "Bounce changes with frame rate",
   "method": "Fixed simulation steps and render interpolation",
   "risk": "Limit catch-up work when frames take too long."
  }
 },
 {
  "tech": "xpbd",
  "ja": {
   "group": "物理",
   "goal": "触ると柔らかく変形してほしい",
   "method": "PBD、剛性調整が重要ならXPBDも比較",
   "risk": "反復数、刻み、体積維持、衝突が費用を決めます"
  },
  "en": {
   "group": "Physics",
   "goal": "Soft deformation when touched",
   "method": "PBD; compare XPBD for stiffness control",
   "risk": "Iterations, time steps, volume preservation, and contacts determine cost."
  }
 },
 {
  "tech": "sweep-prune",
  "ja": {
   "group": "物理",
   "goal": "接触候補の比較が重い",
   "method": "Sweep-and-Prune、空間分割",
   "risk": "候補抽出だけでは正確な接触は求まりません"
  },
  "en": {
   "group": "Physics",
   "goal": "Too many collision comparisons",
   "method": "Sweep-and-prune or spatial partitioning",
   "risk": "Candidate pairs still need accurate contact tests."
  }
 },
 {
  "tech": "stable",
  "ja": {
   "group": "流体",
   "goal": "煙や染料を動かしたい",
   "method": "格子上の移流・圧力解法（Stable Fluids）",
   "risk": "格子数と圧力反復が増え、細部が散逸します"
  },
  "en": {
   "group": "Fluids",
   "goal": "Moving smoke or dye",
   "method": "Grid advection and pressure projection",
   "risk": "Grid resolution and pressure iterations cost time. Fine detail can dissipate."
  }
 },
 {
  "tech": "sph",
  "ja": {
   "group": "流体",
   "goal": "水滴や流れる液体を触りたい",
   "method": "SPH、PBFなどの粒子法",
   "risk": "近傍探索、境界、表面生成が別々に必要です"
  },
  "en": {
   "group": "Fluids",
   "goal": "Interactive drops and flowing liquid",
   "method": "Particle methods such as SPH or PBF",
   "risk": "Neighbor search, boundaries, and surface generation are separate tasks."
  }
 },
 {
  "tech": "gerstner-waves",
  "ja": {
   "group": "流体",
   "goal": "広い海面を見せたい",
   "method": "少数のGerstner波、広帯域ならFFT海面",
   "risk": "砕波や流れ、物体周囲の液体を自動で解く方式ではありません"
  },
  "en": {
   "group": "Fluids",
   "goal": "A large ocean surface",
   "method": "Gerstner waves; FFT for a wider spectrum",
   "risk": "Surface waves do not automatically solve breaking waves or local fluid flow."
  }
 },
 {
  "tech": "temporal-aa",
  "ja": {
   "group": "画像",
   "goal": "細部がちらつく",
   "method": "Mipmap、AA、Temporal AA",
   "risk": "過去画素を使う方式は残像や遮蔽変化が課題です"
  },
  "en": {
   "group": "Images",
   "goal": "Flickering fine detail",
   "method": "Mipmaps, AA, or temporal AA",
   "risk": "History-based methods must handle ghosting and changing visibility."
  }
 },
 {
  "tech": "hdr-tonemapping",
  "ja": {
   "group": "画像",
   "goal": "明暗差や発光感を整えたい",
   "method": "HDR・トーンマップ、必要なBloom",
   "risk": "Bloomを強くすると輪郭やUIが読みにくくなります"
  },
  "en": {
   "group": "Images",
   "goal": "Control brightness and glow",
   "method": "HDR, tone mapping, and selective bloom",
   "risk": "Strong bloom can obscure silhouettes and UI."
  }
 },
 {
  "tech": "dlss2",
  "ja": {
   "group": "画像",
   "goal": "ピクセル処理が重い",
   "method": "解像度調整、再構成を比較",
   "risk": "再構成にも費用があり、生成フレームは入力更新を増やしません"
  },
  "en": {
   "group": "Images",
   "goal": "Expensive pixel shading",
   "method": "Compare resolution scaling and reconstruction",
   "risk": "Reconstruction has a cost. Generated frames do not add input updates."
  }
 },
 {
  "tech": "gpu-instancing",
  "ja": {
   "group": "GPU",
   "goal": "同じ小物が大量にある",
   "method": "Instancing",
   "risk": "異なる材質や描画順によって分割されます"
  },
  "en": {
   "group": "GPU",
   "goal": "Many copies of a prop",
   "method": "Instancing",
   "risk": "Material differences and draw order can split batches."
  }
 },
 {
  "tech": "coherent-occlusion",
  "ja": {
   "group": "GPU",
   "goal": "見えない物まで描いている",
   "method": "視錐台判定、遮蔽判定、室内ならPVS",
   "risk": "判定にも費用があります。開放空間では遮蔽効果が小さいです"
  },
  "en": {
   "group": "GPU",
   "goal": "Invisible objects still render",
   "method": "Frustum culling, occlusion, or indoor PVS",
   "risk": "Culling has a cost. Open spaces may provide little occlusion."
  }
 },
 {
  "tech": "astar",
  "ja": {
   "group": "AI",
   "goal": "敵が目的地へ行けない",
   "method": "A*とNavmesh、局所回避を分ける",
   "risk": "通れる経路と、他者を避ける速度は別の問題です"
  },
  "en": {
   "group": "AI",
   "goal": "Enemies cannot reach a destination",
   "method": "A*, navmeshes, and separate local avoidance",
   "risk": "A valid path does not provide collision-free movement around other agents."
  }
 },
 {
  "tech": "goap-fear",
  "ja": {
   "group": "AI",
   "goal": "行動条件が絡み合う",
   "method": "Behavior Tree、計画が必要ならGOAP",
   "risk": "分岐の競合、計画の再計算、説明しにくい選択が増えます"
  },
  "en": {
   "group": "AI",
   "goal": "Tangled action conditions",
   "method": "Behavior trees; GOAP when planning is needed",
   "risk": "Check competing branches, replanning cost, and unclear choices."
  }
 },
 {
  "tech": "utility-ai",
  "ja": {
   "group": "AI",
   "goal": "状況で行動の優先度を変えたい",
   "method": "Utility AI",
   "risk": "点数の尺度が揃わないと、一つの行動に偏ります"
  },
  "en": {
   "group": "AI",
   "goal": "Priorities should change with context",
   "method": "Utility AI",
   "risk": "Inconsistent score scales can make one action dominate."
  }
 },
 {
  "tech": "client-interpolation",
  "ja": {
   "group": "通信",
   "goal": "自分の操作が遅い、他人が跳ぶ",
   "method": "ローカル予測・補正と他者補間",
   "risk": "予測外れと補間の待ち時間を別々に測ります"
  },
  "en": {
   "group": "Networking",
   "goal": "Local input lags; remote players jump",
   "method": "Local prediction and reconciliation; remote interpolation",
   "risk": "Measure prediction errors and interpolation delay separately."
  }
 },
 {
  "tech": "rollback-ggpo",
  "ja": {
   "group": "通信",
   "goal": "格闘などで入力待ちを減らしたい",
   "method": "Rollback",
   "risk": "再実行できる決定的な状態と計算余力が必要です"
  },
  "en": {
   "group": "Networking",
   "goal": "Reduce input waiting in fighting games",
   "method": "Rollback",
   "risk": "State must be reproducible. Re-simulation needs spare processing time."
  }
 },
 {
  "tech": "tribes-replication",
  "ja": {
   "group": "通信",
   "goal": "大勢の状態を配れない",
   "method": "AOI、優先度、差分複製",
   "risk": "視界だけで必要性を決めると攻撃や音の情報が欠けます"
  },
  "en": {
   "group": "Networking",
   "goal": "Too many state updates",
   "method": "Interest management, priorities, and delta replication",
   "risk": "Visibility alone can omit important attack or sound information."
  }
 },
 {
  "tech": "kemar-hrtf",
  "ja": {
   "group": "音響",
   "goal": "音源の方向が分かりにくい",
   "method": "HRTF、距離減衰",
   "risk": "個人差があります。遮音と反響は別の処理です"
  },
  "en": {
   "group": "Audio",
   "goal": "Unclear sound direction",
   "method": "HRTF and distance attenuation",
   "risk": "Results vary by listener. Occlusion and reverberation are separate tasks."
  }
 },
 {
  "tech": "data-oriented-design",
  "ja": {
   "group": "基盤",
   "goal": "物体数が増えるとCPUが重い",
   "method": "データの配置と更新単位を見直す",
   "risk": "ECSという名前だけでは高速化しません"
  },
  "en": {
   "group": "Runtime",
   "goal": "CPU cost grows with object count",
   "method": "Review data layout and update batches",
   "risk": "The ECS label alone does not guarantee faster execution."
  }
 },
 {
  "tech": "texture-clipmap",
  "ja": {
   "group": "基盤",
   "goal": "移動時に読み込みが止まる",
   "method": "常駐量、先読み、段階的ロード",
   "risk": "読み込み、復号、GPU転送のどこが詰まるか分けます"
  },
  "en": {
   "group": "Runtime",
   "goal": "Movement causes loading stalls",
   "method": "Residency budgets, prefetching, and staged loading",
   "risk": "Measure reading, decoding, and GPU transfer separately."
  }
 },
 {
  "tech": "wave-function-collapse",
  "ja": {
   "group": "基盤",
   "goal": "多様な小部屋や模様を作りたい",
   "method": "制約付き生成、WFC",
   "risk": "矛盾や失敗があり、遊べる地形を保証しません"
  },
  "en": {
   "group": "Runtime",
   "goal": "Generate varied rooms or patterns",
   "method": "Constraint generation such as WFC",
   "risk": "Contradictions can occur. Valid constraints do not guarantee playable layouts."
  }
 },
 {
  "tech": "blast-bonds",
  "ja": {
   "group": "破壊",
   "goal": "決まった物を気持ちよく壊したい",
   "method": "事前分割した破片と破壊演出",
   "risk": "当たり判定と小片数の上限を先に決めます"
  },
  "en": {
   "group": "Destruction",
   "goal": "Break authored objects convincingly",
   "method": "Pre-fractured pieces and impact feedback",
   "risk": "Set collision rules and fragment count limits first."
  }
 },
 {
  "tech": "brittle-fracture",
  "ja": {
   "group": "破壊",
   "goal": "任意の場所を切りたい",
   "method": "実行時切断・破砕",
   "risk": "断面生成、形状不良、コライダー更新が高価です"
  },
  "en": {
   "group": "Destruction",
   "goal": "Cut at arbitrary locations",
   "method": "Runtime cutting or fracture",
   "risk": "New surfaces, invalid geometry, and collider updates can be expensive."
  }
 },
 {
  "tech": "chaos-clusters",
  "ja": {
   "group": "破壊",
   "goal": "支えを壊すと崩れてほしい",
   "method": "接続グラフ、必要なら構造解析",
   "risk": "接続を切る判定と連続体の応力計算は異なります"
  },
  "en": {
   "group": "Destruction",
   "goal": "Collapse after supports break",
   "method": "Bond graphs; structural analysis when needed",
   "risk": "Breaking graph edges differs from solving continuum stress."
  }
 },
 {
  "tech": "destruction-cache",
  "ja": {
   "group": "破壊",
   "goal": "大崩落で停止する",
   "method": "大片だけ物理、小片は演出、キャッシュも比較",
   "risk": "演出用破片に、通路を塞ぐ責任を持たせないようにします"
  },
  "en": {
   "group": "Destruction",
   "goal": "Large collapses stall the game",
   "method": "Simulate large chunks; use effects or caches for small debris",
   "risk": "Decorative fragments should not determine whether a path is blocked."
  }
 }
];
